import {
    get,
    post,
    put
} from "./http";
import qs from 'qs'

// 左上-新材料(炭基导电)企业数量统计
export const getIndustrialLeftTopOne = (params) => {
    let url = "/jysk/brain/industrial/run/left/one/list";
    return get(url, params);
}

// 左上-新材料(炭基导电)企业数量统计
export const getIndustrialLeftTopTwo = (params) => {
    let url = "/jysk/brain/industrial/run/left/two/list";
    return get(url, params);
}

// 左下-新材料(炭基导电)产业开工率趋势
export const getIndustrialLeftTopTree = (params) => {
    let url = "/jysk/brain/industrial/run/left/three/list";
    return get(url, params);
}

// 右上-全国新材料(炭基导电)企业数量
export const getIndustrialRightTopOne = (params) => {
    let url = "/jysk/brain/industrial/run/nationwide/enterprise/count/list";
    return get(url, params);
}

// 右中-全国新材料(炭基导电)金字塔
export const getIndustrialRightTopTwo = (params) => {
    let url = "/jysk/brain/industrial/run/enterprise/pyramid/structure/list";
    return get(url, params);
}

// 右下-企业资本注册分布
export const getIndustrialRightTopTree = (params) => {
    let url = "/jysk/brain/industrial/run/enterprise/register/capital/list";
    return get(url, params);
}

// 中间地图，产品类型
export const getIndustrialCenterProductType = (params) => {
    let url = "/jysk/brain/industrial/center/product/type";
    return get(url, params);
}

// 中间地图
export const getIndustrialCenterMap = (params) => {
    let url = "/jysk/brain/industrial/run/industry/map";
    return get(url, params);
}

// 中间地图-原材料市场趋势
export const getIndustrialCenterMarket = (params) => {
    let url = "/jysk/brain/industrial/run/market/trend/list";
    return get(url, params);
}

// 中间地图-地区下拉
export const getIndustrialCenterArea = (params) => {
    let url = "/jysk/brain/industrial/center/area/list";
    return get(url, params);
}


// 中间地图-详情
export const getIndustrialCenterMapDetail = (params) => {
    let url = "/jysk/brain/industrial/center/detail/map";
    return get(url, params);
}

// 轮播表数据
export const getVitalIndices = (params) => {
    let url = "/jysk/brain/industrial/run/left/vital/indices";
    return get(url, params);
}

